import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {CsvErrorsService} from '@drl/shared/facades/csv-errors.service';
import {CsvUploadReport} from '@drl/shared/models/csv-upload-report.model';
import {NbDialogRef} from '@nebular/theme';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-bulk-upload-result',
  templateUrl: './bulk-upload-result.component.html',
  styleUrls: ['./bulk-upload-result.component.scss'],
})
export class BulkUploadResultComponent implements OnInit {
  loading = false;
  errReport: CsvUploadReport;
  btnLoad = false;
  translate: TranslateService;
  csvResultMsgLbl: string;
  viewReportMsgLbl: string;
  constructor(
    protected dialogRef: NbDialogRef<BulkUploadResultComponent>,
    private readonly translateSvc: IpsTranslateService,
    private readonly csvErrorsReport: CsvErrorsService,
    private readonly router: Router,
  ) {
    this.translate = this.translateSvc.translate;
  }
  ngOnInit() {
    this.getTranslations();
  }

  getTranslations() {
    this.loading = true;
    this.translate
      .get(['csvResultMsgLbl', 'viewReportMsgLbl', 'viewReportBtnLbl'], {
        successCount: this.errReport.successCount,
        totalCount: this.errReport.totalCount,
      })
      .subscribe(
        res => {
          this.csvResultMsgLbl = res.csvResultMsgLbl;
          this.viewReportMsgLbl = res.viewReportMsgLbl;
          this.loading = false;
        },
        err => {
          this.loading = false;
        },
      );
  }

  viewReport() {
    this.btnLoad = true;
    this.csvErrorsReport.csvErrors.next(this.errReport);
    this.btnLoad = false;
    this.router.navigate([`main/csv-report`]);
    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
